import { nanoid } from '@reduxjs/toolkit'
import type { TNode } from 'platejs'

import {
  withoutMergingHistory,
  withoutSavingHistory,
} from '../../../BufferEditor/history'
import type { BufferEditor } from '../../../BufferEditor/types.plate'
import { editorDebug } from '../../../editorDebug'
import { LinkElement } from '../nodes/LinkElement'

export function replaceLinkWithShortLink(
  editor: BufferEditor,
  link: string,
  shortLink: string,
): void {
  // The shortLinkId allows for undoing shortlinks.
  // Without it, the Composer would re-shorten the link.
  const shortLinkId = nanoid()

  const match = (n: TNode): boolean => LinkElement.is(n) && n.url === link

  editorDebug('replaceLinkWithShortLink %s %s', link, shortLink)

  editor.tf.withoutNormalizing(() => {
    withoutSavingHistory(editor, () => {
      editor.tf.setNodes<LinkElement>(
        {
          shortUrl: shortLink,
          isShortened: false,
          shortLinkId,
        },
        {
          at: [],
          match: (n) => {
            return match(n) && !n.isShortened
          },
        },
      )
    })

    withoutMergingHistory(editor, () => {
      editor.tf.setNodes<LinkElement>(
        {
          isShortened: true,
        },
        {
          at: [],
          match: (n) => match(n) && n.shortLinkId === shortLinkId,
        },
      )
    })
  })
}
